import React from 'react';
import { COLORS } from '../../utils/colors';
import { Box, Typography } from '@mui/material';

const NotFound = () => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" height="100vh" bgcolor={COLORS.LIGHT_GRAY}>
      <Typography style={{ fontWeight: 500, fontSize: '20px', margin: 'auto' }}>PAGE NOT FOUND!</Typography>
    </Box>
  );
};

export default NotFound;
